import React, { FC } from 'react';
import styles from './index.module.scss';

interface TrackSkeletonProps {
  withPerformerTitle?: boolean;
  withExplicit?: boolean;
  withTime?: boolean;
  withLike?: boolean;
  withDislike?: boolean;
}

const SkeletonItem: FC<TrackSkeletonProps> = (props) => {
  const { withPerformerTitle, withExplicit, withTime, withLike, withDislike } = props;

  return (
    <div className={styles.SkeletonItem}>
      <div className={styles.SkeletonItemContainer}>
        <div className={styles.SkeletonItemButton} />

        <div className={styles.SkeletonItemText}>
          <div className={styles.SkeletonItemTextTitle} />
          {withPerformerTitle && <div className={styles.SkeletonItemTextPerformerTitle} />}
        </div>
      </div>

      <div className={styles.SkeletonItemIcons}>
        {withExplicit && <div className={styles.SkeletonItemIconsExplicit} />}
        {withLike && <div className={styles.SkeletonItemIconsExplicit} />}
        {withDislike && <div className={styles.SkeletonItemIconsExplicit} />}
        {withTime && <div className={styles.SkeletonItemIconsTime} />}
      </div>
    </div>
  );
};

export default SkeletonItem;
